import { AXIOS } from "../customAxios";

export async function getUserProfile({ clientId }: { clientId: string }) {
  const url = clientId ? '/api/client/common/userDetails/read' : '/api/super/userDetails/read'
  const data = await AXIOS.get(url);

  return data;
}

export async function updateUserProfile({
  userDetailsInfo, profileImage, clientId }: {
    userDetailsInfo: string,
    profileImage: File | null,
    clientId: string
  }) {

  const url = clientId ? '/api/client/common/userDetails/updateInfo' : '/api/super/userDetails/updateInfo'
  const data = await AXIOS.post(url, { profileImage }, {
    headers: {
      clientId: "-1",
      "Content-Type": "multipart/form-data"
    },
    params: { otherUserDetails: userDetailsInfo }
  });

  return data;
}

export async function getProfilePicture(url: string) {
  const res = await fetch(url);
  const imgBlob = await res.blob();
  const imageObjUrl = URL.createObjectURL(imgBlob)

  return imageObjUrl;
}